import { handlePostRequest } from "../hooks/api";

async function handleFollowUser(targetUserId) {
  const payload = {
    followedUserId: targetUserId
  };
  const response = await handlePostRequest(
    "/follow",
    payload,
    undefined,
    false
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
}

async function handleUnfollowUser(targetUserId) {
  const payload = {
    followedUserId: targetUserId
  };
  const response = await handlePostRequest(
    "/unfollow",
    payload,
    undefined,
    false
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
}

async function handleGetUserFollowers(targetUserId) {
  const payload = {
    userid: targetUserId
  };
  const response = await handlePostRequest("/followers", payload, {}, false);
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
}

async function handleGetUserFollowings(targetUserId) {
  const payload = {
    userid: targetUserId
  };
  const response = await handlePostRequest("/followings", payload, {}, false);
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
}

export default {
  handleFollowUser,
  handleUnfollowUser,
  handleGetUserFollowers,
  handleGetUserFollowings
};
